import { QueryConfig } from "store/utils/query-config";

export const brandsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"],
  },
};
